module.exports = __webpack_public_path__ + "static/media/skule.5da8e01b.png";